<div class="header-div d-flex justify-content-center">
  <h6 class="text-uppercase mb-0 text-center">{{ title }}</h6>
</div>

@if (isFormLoading) {
  <app-rings-loader></app-rings-loader>
}

@if (!isFormLoading && stepperConfig) {
  <app-stepper-container [config]="stepperConfig"
    (stepChanged)="onStepChanged($event)">
  </app-stepper-container>
}

<ng-template #nsStepTpl>
  <div class="form-fields-body ns-step">

    @if (currentStep?.id === 'trigger') {
      <div class="row">
        @for (field of triggerFields; track trackByIndex($index)) {
          <app-dynamic-form-field [field]="field" [entity]="entity"
          (valueChanged)="updateFieldVisibility()"></app-dynamic-form-field>
        }
      </div>
    }

    @if (currentStep?.id === 'schedule') {
      <div class="row">
        @for (field of nonShiftScheduleFields; track trackByIndex($index)) {
          <app-dynamic-form-field [field]="field" [entity]="entity"
          (valueChanged)="updateFieldVisibility()"></app-dynamic-form-field>
        }
      </div>
      @if (entity.shifts?.length) {
        <div class="ns-shifts">
          @for (shift of entity.shifts; track trackByIndex(i); let i = $index) {
            <div class="ns-shift-row">
              <mat-form-field class="ns-shift-time">
                <mat-label class="field-label">{{ 'Start Time' | translate }}</mat-label>
                <input matInput class="time-input" [(ngModel)]="shift.startDate"
                  (ngModelChange)="onShiftTimeChange($event, i, shiftsField.items[i][0])"
                  [ngxMatTimepicker]="startPicker" [format]="'' | hour12Flag" />
                  <ngx-mat-timepicker-toggle matSuffix [for]="startPicker"></ngx-mat-timepicker-toggle>
                  <ngx-mat-timepicker #startPicker appendToInput="true"></ngx-mat-timepicker>
                </mat-form-field>
                <mat-form-field class="ns-shift-time">
                  <mat-label class="field-label">{{ 'End Time' | translate }}</mat-label>
                  <input matInput class="time-input" [(ngModel)]="shift.endDate"
                    (ngModelChange)="onShiftTimeChange($event, i, shiftsField.items[i][1])"
                    [ngxMatTimepicker]="endPicker" [format]="'' | hour12Flag" />
                    <ngx-mat-timepicker-toggle matSuffix [for]="endPicker"></ngx-mat-timepicker-toggle>
                    <ngx-mat-timepicker #endPicker appendToInput="true"></ngx-mat-timepicker>
                  </mat-form-field>
                  <button mat-icon-button color="warn" class="ns-shift-remove" (click)="removeShift(i)"
                    [attr.aria-label]="'Remove' | translate">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              }
            </div>
          }
        }

        @if (currentStep?.id === 'alerting') {
          <div class="row">
            @for (field of alertingFields; track trackByIndex($index)) {
              <app-dynamic-form-field [field]="field" [entity]="entity"
              (valueChanged)="updateFieldVisibility()"></app-dynamic-form-field>
            }
          </div>
        }

        @if (currentStep?.id === 'recipients') {
          <div class="row">
            @for (field of recipientFields; track trackByIndex($index)) {
              <app-dynamic-form-field [field]="field" [entity]="entity"
              (valueChanged)="updateFieldVisibility()"></app-dynamic-form-field>
            }
          </div>
        }

      </div>
    </ng-template>
